import { ArrowUp, Facebook, Linkedin, Mail, Phone } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#090D16] py-16 text-white">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="flex flex-col gap-12 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="font-serif text-4xl font-medium leading-none tracking-tight sm:text-5xl lg:text-6xl">
            Janusz <span className="italic text-[#D8B07C]">Błotnicki</span>
          </p>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-white/50">
            Nieruchomości • Ekspansja • Development Management
          </p>
        </div>
        <div className="flex items-center gap-4">
          <a
            href="tel:+48573569181"
            data-testid="footer-phone-link"
            aria-label="Telefon"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors duration-300 hover:border-[#D8B07C] hover:text-[#D8B07C]"
          >
            <Phone size={16} />
          </a>
          <a
            href="mailto:janusz@blotnicki.pl"
            data-testid="footer-email-link"
            aria-label="E-mail"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors duration-300 hover:border-[#D8B07C] hover:text-[#D8B07C]"
          >
            <Mail size={16} />
          </a>
          <a
            href="https://www.linkedin.com/in/janusz-b%C5%82otnicki-60b935244/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin-link"
            aria-label="LinkedIn"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors duration-300 hover:border-[#D8B07C] hover:text-[#D8B07C]"
          >
            <Linkedin size={16} />
          </a>
          <a
            href="https://www.facebook.com/people/Janusz-B%C5%82otnicki-Nieruchomo%C5%9Bci/61591745414359/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            aria-label="Facebook"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors duration-300 hover:border-[#D8B07C] hover:text-[#D8B07C]"
          >
            <Facebook size={16} />
          </a>
          <a
            href="#start"
            data-testid="footer-scroll-top-button"
            aria-label="Do góry"
            className="flex h-11 w-11 items-center justify-center rounded-full bg-[#8C6D46] text-white transition-colors duration-300 hover:bg-[#735733]"
          >
            <ArrowUp size={16} />
          </a>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
        <p>© 2026 Janusz Błotnicki — Investment &amp; Expansion Partner</p>
        <p className="font-mono uppercase tracking-[0.18em]">
          Podkarpackie • Małopolskie • Lubelskie • Świętokrzyskie
        </p>
      </div>
    </div>
  </footer>
);
